import React from 'react';

interface ActivatedPacksHeaderProps {
  totalPacks: number;
}

export const ActivatedPacksHeader: React.FC<ActivatedPacksHeaderProps> = ({ totalPacks }) => {
  // Return null to remove the header completely
  return null;
}; 